import { useDispatch } from 'react-redux';
import MojitoServices from 'mojito/services';
import { useEffect } from 'react';
import { omit } from 'mojito/utils';

const betslipActions = MojitoServices.Betslip.actions;

/**
 * HoC wraps StakeInput implementation with sports betslip specific handling.
 *
 * @function withSportBetStake
 * @param {React.ReactElement} StakeInput - Stake input view implementation.
 * @returns {React.ReactElement} Stake input react component.
 * @memberof Mojito.Modules.BetslipView
 * @private
 */
export default function withSportBetStake(StakeInput) {
    return function BetStakeInput(props) {
        const { betId } = props;
        const dispatch = useDispatch();

        const onStakeChange = ({ stake, isEachWay }) =>
            dispatch(betslipActions.setStake({ stake, betId, isEachWay }));
        const onStakeChangeIntent = () => dispatch(betslipActions.prepareSetStake(betId));

        useEffect(() => {
            return () => betslipActions.invalidateSetStake(betId);
        }, [betId]);

        return (
            <StakeInput
                {...omit(props, 'betId')}
                onStakeChange={onStakeChange}
                onStakeChangeIntent={onStakeChangeIntent}
            />
        );
    };
}
